export default __webpack_public_path__ + "static/media/PeopleIco.afe5772d.svg";